module.exports = __webpack_public_path__ + "static/Casa-Vietnam-Milano-2024-9f9341a2e9899a6dc22271c881919a1b.pdf";